/** Max stall retries for gallery card and lightbox video playback */
export const CARD_MAX_STALL_RETRIES = 3;

/** Debounce time (ms) after programmatic scroll before re-enabling scroll detection */
export const SCROLL_DEBOUNCE_MS = 800;

/** Audio detection window (ms) for Chromium webkitAudioDecodedByteCount polling */
export const AUDIO_DETECTION_WINDOW_MS = 4000;

/** Audio detection poll interval (ms) */
export const AUDIO_DETECTION_POLL_INTERVAL_MS = 500;
